import React, { useState, useEffect } from "react";
import hero1 from "../assets/hol2.jpg";
import hero2 from "../assets/hol4.jpg";
import hero3 from "../assets/hol5.jpg";
import computer from "../assets/computer.webp";
import cantine from "../assets/cantine.webp";
import libary from "../assets/libary.webp";
import digital from "../assets/digital.webp";
import game from "../assets/game.webp";
import bus from "../assets/bus.png";
import labotary from "../assets/labotary.webp";

import { FaArrowRight, FaArrowLeft, FaTimes } from "react-icons/fa";

const Features = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleItemClick = (images) => {
    setSelectedImages(images);
    setCurrentIndex(0);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleNext = () => {
    if (currentIndex < selectedImages.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up on component unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  return (
    <div className="flex justify-center items-center md:px-0 px-4">
      <div className="md:w-10/12">
        <h2
          data-aos-duration="1500"
          data-aos="slide-right"
          className="text-2xl font-bold mb-10 font-serif"
        >
          Our Facilities
        </h2>
        <div className="grid grid-cols-1 gap-16 md:grid-cols-3">
          {courses.map((course, index) => (
            <div
              key={index}
              onClick={() => handleItemClick(course.images)}
              className="relative overflow-hidden bg-cover bg-no-repeat cursor-pointer"
            >
              <img
                src={course.image.src}
                alt={course.image.alt}
                className="h-80 w-full object-cover rounded-lg transition duration-700 ease-in-out hover:scale-110"
              />
              <div
                className="bg-white bg-opacity-80 p-4 absolute bottom-0 left-0 right-0 transition duration-300 ease-in-out"
                style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold">{course.title}</h3>
                    <p className="text-sm text-primary-350 line-clamp-1">
                      {course.description}
                    </p>
                  </div>
                  <FaArrowRight className="ml-2 text-gray-700 hover:text-gray-900 transition duration-300 ease-in-out" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isModalOpen && (
        <Modal
          images={selectedImages}
          currentIndex={currentIndex}
          onClose={closeModal}
          onNext={handleNext}
          onPrev={handlePrev}
          onBackgroundClick={handleBackgroundClick}
        />
      )}
    </div>
  );
};

const Modal = ({
  images,
  currentIndex,
  onClose,
  onNext,
  onPrev,
  onBackgroundClick,
}) => {
  return (
    <div
      className="fixed inset-0 px-2 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onBackgroundClick}
    >
      <div className="relative bg-white p-8 rounded-lg max-w-3xl mx-auto">
        <button
          className="absolute top-2 right-2 text-black md:text-2xl text-xl"
          onClick={onClose}
        >
          <FaTimes />
        </button>
        <div className="flex px-4 items-center justify-center">
          <button
            onClick={onPrev}
            disabled={currentIndex === 0}
            className={`md:text-2xl text-xl ${
              currentIndex === 0 ? "text-gray-500" : "text-black"
            }`}
          >
            <FaArrowLeft />
          </button>
          <img
            src={images[currentIndex].src}
            alt={images[currentIndex].alt}
            className="w-full h-auto object-cover rounded-lg mx-4"
          />
          <button
            onClick={onNext}
            disabled={currentIndex === images.length - 1}
            className={`md:text-2xl text-xl ${
              currentIndex === images.length - 1
                ? "text-gray-500"
                : "text-black"
            }`}
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Features;

const courses = [
  {
    title: "Library",
    description:
      "Our Features Library offers innovative tools and resources to enhance productivity and creativity.",
    image: {
      src: libary,
      alt: "City 1",
    },
    images: [
      { src: hero1, alt: "Image 1" },
      { src: hero2, alt: "Image 2" },
      { src: hero3, alt: "Image 3" },
      { src: hero1, alt: "Image 4" },
      { src: hero2, alt: "Image 5" },
    ],
  },

  {
    title: "Digital Class Room",
    description:
      "Digital Class Room offers interactive, tech-enabled learning environments for enhanced educational experiences. ",
    image: {
      src: digital,
      alt: "City 3",
    },
    images: [
      { src: hero1, alt: "Image 1" },
      { src: hero2, alt: "Image 2" },
      { src: hero3, alt: "Image 3" },
      { src: hero1, alt: "Image 4" },
      { src: hero2, alt: "Image 5" },
    ],
  },
  {
    title: "Computer Lab",
    description:
      "The Computer Lab provides state-of-the-art technology and resources for hands-on computing and research.",
    image: {
      src: computer,
      alt: "City 2",
    },
    images: [
      { src: hero1, alt: "Image 1" },
      { src: hero2, alt: "Image 2" },
      { src: hero3, alt: "Image 3" },
      { src: hero1, alt: "Image 4" },
      { src: hero2, alt: "Image 5" },
    ],
  },
  {
    title: "Game",
    description:
      "Our Game section offers engaging and interactive activities for fun and learning.",
    image: {
      src: game,
      alt: "City 3",
    },
    images: [
      { src: hero1, alt: "Image 1" },
      { src: hero2, alt: "Image 2" },
      { src: hero3, alt: "Image 3" },
      { src: hero1, alt: "Image 4" },
      { src: hero2, alt: "Image 5" },
    ],
  },

  {
    title: "Laboratory",
    description:
      "Our Laboratory features advanced equipment for hands-on scientific experiments and research.",
    image: {
      src: labotary,
      alt: "City 3",
    },
    images: [
      { src: hero1, alt: "Image 1" },
      { src: hero2, alt: "Image 2" },
      { src: hero3, alt: "Image 3" },
      { src: hero1, alt: "Image 4" },
      { src: hero2, alt: "Image 5" },
    ],
  },

  {
    title: "Bus",
    description:
      "Our Bus service ensures safe and reliable transportation for students and staff. ",
    image: {
      src: bus,
      alt: "City 3",
    },
    images: [
      { src: hero1, alt: "Image 1" },
      { src: hero2, alt: "Image 2" },
      { src: hero3, alt: "Image 3" },
      { src: hero1, alt: "Image 4" },
      { src: hero2, alt: "Image 5" },
    ],
  },

  {
    title: "Cantine ",
    description:
      "Our Canteen offers a variety of nutritious and delicious meals in a comfortable dining environment. ",
    image: {
      src: cantine,
      alt: "City 3",
    },
    images: [
      { src: hero1, alt: "Image 1" },
      { src: hero2, alt: "Image 2" },
      { src: hero3, alt: "Image 3" },
      { src: hero1, alt: "Image 4" },
      { src: hero2, alt: "Image 5" },
    ],
  },
];
